import React from 'react';
import { QUERY_SHOP } from '../../graphql/query/shop/shop.query';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GetPublicShopQuery } from '../../graphql/generated/graphql';
import { useQuery } from '@apollo/client';
import { RouteComponentProps } from 'react-router';
import { ProductTypes } from '../../types/product/product';
import FilterBar from '../Reporting/FilterBar';
import ProductsLoop from '../Reporting/ProductsLoop';
import { useDispatch, useSelector } from 'react-redux';
import { setProducts } from '../../store/actions/productFilter.action';
import pages from '../../routes/pages';
import { useHistory } from 'react-router-dom';
import { getGoToPage } from '../../helpers/page/goToPage';
import { getProductTypesFromQuery } from '../../helpers/transformApiResponse/product';
import { AppState } from '../../store/reducers';

interface MatchParams {
  shopId: string;
  classeId: string;
}

type PublicShopProps = RouteComponentProps<MatchParams>;

export const PublicShopPage = ({
  match: {
    params: { shopId, classeId }
  }
}: PublicShopProps) => {
  const products = useSelector(
    (state: AppState) => state.productFilter.products
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading, error } = useQuery<GetPublicShopQuery>(QUERY_SHOP, {
    variables: { id: shopId, classeId: classeId },
    onCompleted: res => {
      if (!products.length) {
        dispatch(
          setProducts(
            res?.shop?.produits?.map(p => getProductTypesFromQuery(p))
          )
        );
      }
    }
  });

  if (loading) return <LoadingLayout variant="centeredOnly" />;
  if (error) return <ErrorContainer text={error.message} />;

  const toSingleProductPublicShop = getGoToPage<{
    idProduit: string;
  }>(history)(pages.PUBLIC_SHOP__SINGLE_PRODUCT.path, shopId, classeId);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <FilterBar />
      </div>
      <ProductsLoop
        onClickNavigate={(idProduit: ProductTypes['id']) => () =>
          toSingleProductPublicShop({ idProduit })}
        isPublicShop={true}
      />
    </>
  );
};
